/**
 * Live invite form — calls mediated `auth.inviteMember`.
 */

import { useState } from 'react';
import { APIError } from '@localagent/sdk';
import { getSDK } from '../../services/sdk-instance';
import { InviteMemberForm } from './InviteMemberForm';

export function InviteMemberFormSection({
  organizationId,
  onInvited,
}: {
  organizationId: string;
  onInvited?: () => void;
}) {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const submit = async () => {
    setSubmitting(true);
    setError(null);
    setSuccess(null);
    try {
      const result = await getSDK().auth.inviteMember(organizationId, {
        email: email.trim(),
      });
      setSuccess(`Invitation sent to ${result.email}`);
      setEmail('');
      onInvited?.();
    } catch (err) {
      // Surface Stytch / API detail verbatim — never swallow.
      if (err instanceof APIError) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError(String(err));
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <InviteMemberForm
      email={email}
      onEmailChange={setEmail}
      onSubmit={() => void submit()}
      isSubmitting={submitting}
      error={error}
      success={success}
    />
  );
}
